"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.values");
var _upload = _interopRequireDefault(require("@/components/upload"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    upload: _upload.default
  },
  name: 'share',
  data: function data() {
    return {
      list: [],
      shareDialog: false,
      shareInfo: {},
      fileList: [],
      share_title: '',
      img_url: '',
      share_id: ''
    };
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      return Object.values(this.$store.state.user.deviceNameObj);
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this = this;
      this.$get('agentapi/system/mini_share').then(function (res) {
        _this.list = res;
      });
    },
    /**
     * 是否隐藏洗衣机分享设置
     */
    tableStyle: function tableStyle(row) {
      if (this.deviceNameObj.indexOf(4) == -1 && row.row.id == 3) {
        return {
          'display': 'none'
        };
      }
    },
    showDialog: function showDialog(row) {
      this.shareDialog = true;
      this.share_id = row.id;
      this.share_title = row.share_title;
      this.img_url = row.img_url;
      this.fileList = [{
        url: row.img_url
      }];
      this.shareInfo = row;
    },
    /**
     * 修改分享信息
     */
    postEdit: function postEdit() {
      var _this2 = this;
      var params = {},
        shareInfo = this.shareInfo;
      params["share_title_".concat(this.share_id)] = this.share_title;
      params["share_imgurl_".concat(this.share_id)] = this.img_url;
      // 【操作埋点】2026-05-25 pc_setting_update_1 小程序分享设置
      this.$post('agentapi/system/mini_share', params).then(function (res) {
        _this2.$settingReport.reportSettingUpdate("mini_share_".concat(_this2.share_id), "\u5C0F\u7A0B\u5E8F\u5206\u4EAB\u8BBE\u7F6E(".concat(_this2.share_id, ")"), {
          title: _this2.shareInfo.share_title,
          img: _this2.shareInfo.img_url
        }, {
          title: _this2.share_title,
          img: _this2.img_url
        });
        _this2.shareDialog = false;
        _this2.shareInfo.share_title = _this2.share_title;
        _this2.shareInfo.img_url = _this2.img_url;
        _this2.$message({
          message: '设置成功',
          type: 'success'
        });
      });
    },
    /**
     * 上传文件成功通知
     */
    fileOk: function fileOk(arr) {
      this.img_url = arr[0] || '';
    }
  }
};